<ts-dialog [title]="title" (closeDialog)="dismiss()">
  <div ts-dialog-body>
    <p>
      @if (renderHtml) {
        <div [innerHTML]="description"></div>
      } @else {
        {{ description }}
      }
    </p>
    @if (isLoading) {
      <div class="loading-row">
        <mat-spinner diameter="18"></mat-spinner>
        <span class="loading-text">{{ loadingText }}</span>
      </div>
    }
    @if (hasError) {
      <p class="error-message">
        {{ errorMessage }}
      </p>
    }
  </div>
  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="cancel()" [disabled]="isLoading">{{ noLabel }}</ts-button>
    <ts-button [variant]="yesStylingVariant" (click)="confirm()" [disabled]="isLoading">{{ yesLabel }}</ts-button>
  </div>
</ts-dialog>

<style>
  .error-message {
    color: #d32f2f;
    margin-top: 16px;
    font-weight: 500;
  }

  .loading-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
  }

  .loading-text {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.72);
  }
</style>
